
let m = angular.module('onEventModule', []);

m.directive('onEvent', require('./onEvent.js'));

module.exports = 'onEventModule';